const observerDefaultOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 1.0,
}

function IntersectionObserverMixin (refList, callbackFn, observerOptions = observerDefaultOptions) {
  return {
    mounted () {
      if (this.sticky) this.initIntersectionObserver()
    },

    methods: {
      initIntersectionObserver () {
        refList.forEach((id) => {
          const callback = (entries, observer) => {
            entries.forEach((entry) => {
              callbackFn(entry, observer)
            })
          }
          const element = this.$refs[id]
          if (!element) return
          const observer = new IntersectionObserver(callback, observerOptions)
          observer.observe(element)
        })
      },
    },
  }
}

export default IntersectionObserverMixin



// WEBPACK FOOTER //
// ./src/mixins/IntersectionObserverMixin.js